module.exports = __webpack_public_path__ + "img/cross_1.59ef624d.png";